export class GlobalConstants {
  public static apiResponseFile: string = "http://localhost:8000/api/response-file/";
  public static apiUrl = 'http://localhost:8080/api';
  // Con long-polling en backend (max 40s/intento), 2 reintentos es suficiente
  // Fase 1: 2 intentos x 40s max = ~80s. Fase 2: 2 más = ~160s total
  public static reintentosSolicitud = 2;
  public static mjeEspera = 'Ingresando Solicitud...';
}
